import { useState } from "react";
import heTosHtml from "../../../../Constants/tos-he";
import enTosHtml from "../../../../Constants/tos-en";
import TermsDialog from "../../../../Components/Modals/TermsDialog";
import LeaveCommunityModal from "../../../../Containers/MyCommunities/LeaveCommunityModal";
import { apiPostRequest } from "../../../../Helpers/Requests";
import { useSnackbar } from "../../../../Components/SnackBar";
import endpoints from "../../../../Helpers/Endpoints";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

const UpdateTos = ({
  tosUpdateDialog,
  remainingTosUpdates,
  setRemainingTosUpdates,
  setTosUpdateDialog,
}) => {
  const showSnackbar = useSnackbar();
  const { t, i18n } = useTranslation("tos-modal");
  const isHebrew = i18n.language === "he";
  // Rejecting updated terms leaves the community — irreversible, and the
  // supplier has to re-apply and be re-approved to come back. It used to fire
  // straight off the link with no confirmation and no reason captured; now it
  // goes through the same confirmation as every other exit.
  const [openLeaveModal, setOpenLeaveModal] = useState(false);
  const handleAcceptTos = async (communityId) => {
    try {
      await apiPostRequest(endpoints.acceptUpdateCommunityTOS, {
        communityId: communityId,
      });
      showSnackbar(t("tos_accepted", { ns: "tos-modal" }), "success");
      // Filter out the accepted community
      const nextTos = remainingTosUpdates.filter(
        (tos) => tos.community_id !== communityId,
      );
      setRemainingTosUpdates(nextTos);
      if (nextTos.length > 0) {
        setTosUpdateDialog({ open: true, community: nextTos[0] });
      } else {
        setTosUpdateDialog({ open: false, community: null });
      }
    } catch (error) {
      showSnackbar(t("tos_accept_failed", { ns: "tos-modal" }), "error");
      console.error("Failed to accept TOS:", error);
    }
  };
  const handleRejectTos = async (communityId, feedback) => {
    try {
      await apiPostRequest(
        endpoints.communityManagementRemoveCommunity(communityId),
        { feedback },
      );
      showSnackbar(t("tos_rejected", { ns: "tos-modal" }), "success");
      setOpenLeaveModal(false);
      // Filter out the rejected community
      const nextTos = remainingTosUpdates.filter(
        (tos) => tos.community_id !== communityId,
      );
      setRemainingTosUpdates(nextTos);
      if (nextTos.length > 0) {
        setTosUpdateDialog({ open: true, community: nextTos[0] });
      } else {
        setTosUpdateDialog({ open: false, community: null });
      }
    } catch (error) {
      showSnackbar(t("tos_reject_failed", { ns: "tos-modal" }), "error");
      console.error("Failed to reject TOS:", error);
    }
  };
  return (
    <>
      <TermsDialog
        openDialog={tosUpdateDialog.open}
        setOpenDialog={(open) =>
          setTosUpdateDialog({ ...tosUpdateDialog, open })
        }
        dialogTitle={
          tosUpdateDialog.community
            ? t("tos_update_title", {
                ns: "tos-modal",
                community_name: tosUpdateDialog.community.community_name,
              })
            : t("tos_title", { ns: "tos-modal" })
        }
        termsDescription={
          tosUpdateDialog.community ? (
            tosUpdateDialog.community.tos_supplier
          ) : (
            <Box
              dangerouslySetInnerHTML={{
                __html: isHebrew ? heTosHtml : enTosHtml,
              }}
            ></Box>
          )
        }
        showActions={!!tosUpdateDialog.community}
        forceActions={!!tosUpdateDialog.community}
        onAccept={
          tosUpdateDialog.community
            ? () => handleAcceptTos(tosUpdateDialog.community.community_id)
            : null
        }
        onReject={
          tosUpdateDialog.community ? () => setOpenLeaveModal(true) : null
        }
      />

      <LeaveCommunityModal
        supplier={tosUpdateDialog.community}
        open={openLeaveModal}
        handleClose={() => setOpenLeaveModal(false)}
        handleOk={(community, feedback) =>
          handleRejectTos(community?.community_id, feedback)
        }
        value="active"
      />
    </>
  );
};

export default UpdateTos;
